import { PowerTransformerState } from './types';

const state = (): PowerTransformerState => {
  return {
    powerTransformers: [],
  };
};

export default state;
